import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countdown'
})
export class CountdownPipe implements PipeTransform {

   
    transform(value: Date | undefined): string {
        if (!value) {
            return 'No Date Provided';
        }

        const now = new Date().getTime();
        const distance = value.getTime() - now;

        if (distance < 0) {
            return 'Time Up';
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const dayStr = days < 10 ? `0${days}` : `${days}`;
        const hourStr = hours < 10 ? `0${hours}` : `${hours}`;
        const minuteStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
        const secondStr = seconds < 10 ? `0${seconds}` : `${seconds}`;

        return `${dayStr}d ${hourStr}h ${minuteStr}m ${secondStr}s`;
    }
}